<template>
  <v-card>
    <v-card-text>
      <form data-vv-scope="insInsdForm">
        <v-container fluid grid-list-sm>
          <v-layout row wrap>
            <v-flex xs12 md4 lg4 v-if="riskSurveyMode === 'Query'">
              <v-subheader class="queryLabel">{{ labels.insdBldg }}</v-subheader>
              <div class="queryValue">{{ insInsdForm.insdBldg }}</div>
            </v-flex>
            <v-flex xs12 md4 lg4 v-else>
              <v-text-field
                :label="labels.insdBldg"
                v-model="insInsdForm.insdBldg"
                :error-messages="errors.collect('insInsdForm.insdBldg')"
                data-vv-name="insInsdForm.insdBldg"
                :data-vv-as="labels.insdBldg"
                v-num-mask="{ negative: false, intScale: 18, decScale: 2 }"
                v-validate="'mask_decimal:2|mask_max_value:999999999999999999.99'"
              ></v-text-field>
            </v-flex>
            <v-flex xs12 md4 lg4 v-if="riskSurveyMode === 'Query'">
              <v-subheader class="queryLabel">{{ labels.insdCont }}</v-subheader>
              <div class="queryValue">{{ insInsdForm.insdCont }}</div>
            </v-flex>
            <v-flex xs12 md4 lg4 v-else>
              <v-text-field
                :label="labels.insdCont"
                v-model="insInsdForm.insdCont"
                :error-messages="errors.collect('insInsdForm.insdCont')"
                data-vv-name="insInsdForm.insdCont"
                :data-vv-as="labels.insdCont"
                v-num-mask="{ negative: false, intScale: 18, decScale: 2 }"
                v-validate="'mask_decimal:2|mask_max_value:999999999999999999.99'"
              ></v-text-field>
            </v-flex>
            <v-flex xs12 md4 lg4 v-if="riskSurveyMode === 'Query'">
              <v-subheader class="queryLabel">{{ labels.insdPlt }}</v-subheader>
              <div class="queryValue">{{ insInsdForm.insdPlt }}</div>
            </v-flex>
            <v-flex xs12 md4 lg4 v-else>
              <v-text-field
                :label="labels.insdPlt"
                v-model="insInsdForm.insdPlt"
                :error-messages="errors.collect('insInsdForm.insdPlt')"
                data-vv-name="insInsdForm.insdPlt"
                :data-vv-as="labels.insdPlt"
                v-num-mask="{ negative: false, intScale: 18, decScale: 2 }"
                v-validate="'mask_decimal:2|mask_max_value:999999999999999999.99'"
              ></v-text-field>
            </v-flex>
            <v-flex xs12 md4 lg4 v-if="riskSurveyMode === 'Query'">
              <v-subheader class="queryLabel">{{ labels.insdRawMat }}</v-subheader>
              <div class="queryValue">{{ insInsdForm.insdRawMat }}</div>
            </v-flex>
            <v-flex xs12 md4 lg4 v-else>
              <v-text-field
                :label="labels.insdRawMat"
                v-model="insInsdForm.insdRawMat"
                :error-messages="errors.collect('insInsdForm.insdRawMat')"
                data-vv-name="insInsdForm.insdRawMat"
                :data-vv-as="labels.insdRawMat"
                v-num-mask="{ negative: false, intScale: 18, decScale: 2 }"
                v-validate="'mask_decimal:2|mask_max_value:999999999999999999.99'"
              ></v-text-field>
            </v-flex>
            <v-flex xs12 md4 lg4 v-if="riskSurveyMode === 'Query'">
              <v-subheader class="queryLabel">{{ labels.insdGoods }}</v-subheader>
              <div class="queryValue">{{ insInsdForm.insdGoods }}</div>
            </v-flex>
            <v-flex xs12 md4 lg4 v-else>
              <v-text-field
                :label="labels.insdGoods"
                v-model="insInsdForm.insdGoods"
                :error-messages="errors.collect('insInsdForm.insdGoods')"
                data-vv-name="insInsdForm.insdGoods"
                :data-vv-as="labels.insdGoods"
                v-num-mask="{ negative: false, intScale: 18, decScale: 2 }"
                v-validate="'mask_decimal:2|mask_max_value:999999999999999999.99'"
              ></v-text-field>
            </v-flex>
            <v-flex xs12 md4 lg4 v-if="riskSurveyMode === 'Query'">
              <v-subheader class="queryLabel">{{ labels.insdPackMat }}</v-subheader>
              <div class="queryValue">{{ insInsdForm.insdPackMat }}</div>
            </v-flex>
            <v-flex xs12 md4 lg4 v-else>
              <v-text-field
                :label="labels.insdPackMat"
                v-model="insInsdForm.insdPackMat"
                :error-messages="errors.collect('insInsdForm.insdPackMat')"
                data-vv-name="insInsdForm.insdPackMat"
                :data-vv-as="labels.insdPackMat"
                v-num-mask="{ negative: false, intScale: 18, decScale: 2 }"
                v-validate="'mask_decimal:2|mask_max_value:999999999999999999.99'"
              ></v-text-field>
            </v-flex>
          </v-layout>
        </v-container>
      </form>
    </v-card-text>
  </v-card>
</template>

<script>
import MessageMixin from '@/mixins/message'
import { formatDisplayDate } from '@/utils/date'
import { formatPrice } from '@/utils/index'

export default {
  data() {
    return {
      labels: {
        insdBldg: 'Building',
        insdCont: 'Contents',
        insdPlt: 'Plant',
        insdRawMat: 'Raw Material',
        insdGoods: 'Finished Good',
        insdPackMat: 'Packing Material'
      },
      insInsdForm: {
        survNo: undefined,
        verCnt: undefined,
        insdBldg: 0,
        insdCont: 0,
        insdPlt: 0,
        insdRawMat: 0,
        insdGoods: 0,
        insdPackMat: 0,
        survDetType: 'interestInsured'
      },
      actionLabel: {
        exit: 'Exit',
        save: 'Save',
        reset: 'Reset'
      },
      loading: false,
      showErrorDialog: false,
      submitting: false
    }
  },
  watch: {
    displayErrorDialog: {
      handler: function (messages) {
        if (messages && messages.length > 0) {
          this.showErrorDialog = true
        }
      },
      deep: true
    }
  },
  computed: {
    displayErrorDialog() {
      return this.messages
    },
    riskSurveyMenu() {
      return this.$store.state.underwriting.specialFuncUWSettings.riskSurveySettings.menu
    },
    riskSurveyMaster() {
      return this.$store.state.underwriting.specialFuncUWSettings.riskSurveyMaster
    },
    riskSurveyDetails() {
      return this.$store.state.underwriting.specialFuncUWSettings.riskSurveyDetails
    },
    riskSurveyMode() {
      return this.$store.state.underwriting.specialFuncUWSettings.riskSurveyMode
    }
  },
  methods: {
    async doInit() {
      this.insInsdForm.survNo = this.riskSurveyMaster.survNo
      this.insInsdForm.verCnt = this.riskSurveyMaster.verCnt
      this.loadInit()
    },
    loadInit() {
      this.insInsdForm.insdBldg = formatPrice(this.riskSurveyDetails.insdBldg)
      this.insInsdForm.insdCont = formatPrice(this.riskSurveyDetails.insdCont)
      this.insInsdForm.insdPlt = formatPrice(this.riskSurveyDetails.insdPlt)
      this.insInsdForm.insdRawMat = formatPrice(this.riskSurveyDetails.insdRawMat)
      this.insInsdForm.insdGoods = formatPrice(this.riskSurveyDetails.insdGoods)
      this.insInsdForm.insdPackMat = formatPrice(this.riskSurveyDetails.insdPackMat)
    },
    formatDate(date) {
      return formatDisplayDate(date)
    },
    formatPrice(data) {
      return formatPrice(data)
    },
    doReset() {
      this.insInsdForm.insdBldg = 0
      this.insInsdForm.insdCont = 0
      this.insInsdForm.insdPlt = 0
      this.insInsdForm.insdRawMat = 0
      this.insInsdForm.insdGoods = 0
      this.insInsdForm.insdPackMat = 0
    }
  },
  created() {},
  mounted() {
    this.doInit()
  },
  beforeMount() {
    if (this.$store.state.underwriting.specialFuncUWSettings.init !== 1) {
      this.$store.dispatch('specialFuncUWInit').then(() => {
        this.$store.dispatch('riskSurveyInit').then(() => {
          this.doInit()
        })
      })
    } else {
      this.$store.dispatch('riskSurveyInit').then(() => {
        this.doInit()
      })
    }
  },
  mixins: [MessageMixin],
  components: {}
}
</script>
<style lang="scss">
@import '../../../../../assets/scss/accounting.scss';
</style>
